import getEnv from "helpers/get_env";

const CONFIG_BY_ENVIRONMENT = {
  development: {
    domain: "upserve.auth0.com",
    clientID: "T72t5alQWwGaHn2MlXVgWX7Fe01uss4D",
    realm: "Swipely-App",
  },
  staging: {
    domain: "upserve-staging.auth0.com",
    clientID: "FkOka1vgZyXhTXiBvEj90uCP1o18cNfX",
    realm: "HQ-Service",
  },
  production: {
    domain: "upserve.auth0.com",
    clientID: "T72t5alQWwGaHn2MlXVgWX7Fe01uss4D",
    realm: "Swipely-App",
  },
};

function auth0Config() {
  return CONFIG_BY_ENVIRONMENT[getEnv()];
}

export default auth0Config;
